import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`
